export const ERRORS = {
  SignWallet: "Please sign in your wallet.",
  SomethingWentWrong: "Something went wrong!"
} as const;
